import type { MembershipApplicationStepId } from "@/features/membership/application/types"
import type {
  MembershipCategoryResponse,
  RequirementDto,
} from "@/utils/api/membership-service/models"

export enum RequirementType {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  CHECKBOX = "CHECKBOX",
  FILE = "FILE",
  SELECT = "SELECT",
  MULTI_SELECT = "MULTI_SELECT",
  DATE = "DATE",
}

export interface Requirement extends RequirementDto {
  type: RequirementType
  createdAt?: string
  updatedAt?: string
}

export interface MembershipCategory extends MembershipCategoryResponse {
  requirements?: Requirement[]
}

export type MembershipCategoryKey = "general" | "student" | "professional" | "corporate"

export type ApplicationFieldKey =
  | "studentId"
  | "institution"
  | "graduationYear"
  | "companyRegistrationNumber"
  | "companySize"
  | "businessSector"
  | "yearsOfExperience"
  | "professionalLicenseNumber"
  | "organisation"
  | "placeOfResident"

export interface MembershipCategorySectionConfig {
  stepId: MembershipApplicationStepId
  isVisible: boolean
  isRequired: boolean
  requiredFields?: ApplicationFieldKey[]
  optionalFields?: ApplicationFieldKey[]
  guidance?: string
  requirementSummaries?: StepRequirementSummary[]
  documentRequirements?: StepRequirementSummary[]
}

export interface MembershipCategoryConfiguration {
  key: MembershipCategoryKey
  title: string
  summary: string
  prerequisites: string[]
  sections: Record<MembershipApplicationStepId, MembershipCategorySectionConfig>
  supportingDocuments?: string[]
}

export interface StepRequirementSummary {
  id?: number
  label: string
  mandatory: boolean
  description?: string
  type: RequirementType
  acceptedFormats?: string[]
}

export interface MembershipCategoryWithConfiguration {
  category: MembershipCategory
  configuration: MembershipCategoryConfiguration
}
